import { MaintenanceNoticeRecord } from '@/types/api/NoticeRecord';
import React from 'react';
import {
  NoticeSourceType,
} from '../types/api/NoticeRecord';

export type MaintenanceNoticeTooltipProps = {
  notice: MaintenanceNoticeRecord;
};

export const SOURCE_ABBREVIATIONS: Record<NoticeSourceType, string> = {
  [NoticeSourceType.CAPACITY_CONSTRAINT]: 'CAP',
  [NoticeSourceType.CONSTRAINED_AREAS]: 'S&C',
  [NoticeSourceType.FORCE_MAJEURE]: 'FMJ',
  [NoticeSourceType.MAINTENANCE]: 'MAI',
  [NoticeSourceType.MAINTENANCE_SCHEDULE]: 'SCH',
  [NoticeSourceType.OPERATIONAL_ALERT]: 'OPA',
  [NoticeSourceType.OPERATIONAL_FLOW_ORDER]: 'OFO',
  [NoticeSourceType.OTHER]: 'GEN',
  [NoticeSourceType.OVER_UNDER_PERFORMANCE]: 'PER',
  [NoticeSourceType.PIPELINE_CONDITIONS]: 'CND',
  [NoticeSourceType.PLANNED_SERVICE_OUTAGE]: 'PSO',
};

export const MaintenanceNoticeTooltip: React.FC<
  MaintenanceNoticeTooltipProps
> = ({ notice }) => {
  return (
    <div className="text-start">
      <h6 className="d-flex justify-content-between align-items-center">
        <span>
          {notice.tsp_name} Notice {notice.notice_id} &nbsp;
        </span>

        <span
          className="px-2"
          style={{
            whiteSpace: 'nowrap',
            backgroundColor: 'var(--bs-secondary-bg)',
            color: 'var(--bs-body-color)',
            borderRadius: '16px',
            fontSize: '0.7rem',
            position: 'relative',
            top: '-1px',
          }}
        >
          {notice.source_type
            ? SOURCE_ABBREVIATIONS[notice.source_type] ?? '???'
            : null}
        </span>
      </h6>{' '}
      <div>
        <strong>Location:</strong> {notice.identifier}
        {notice.display_values?.direction
          ? ` (${notice.display_values?.direction})`
          : ''}
      </div>{' '}
      <div>
        <strong>Dates:</strong> {notice.display_values?.date_range}
      </div>
      <div>
        <strong>Effect:</strong> {notice.display_values?.effect_text}
      </div>
    </div>
  );
};
